import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconSuccess = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke="none"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47716 6.47716 2 12 2C17.5229 2 22 6.47716 22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99991 13.9192L16.6261 7.29297L18.0404 8.70718L10.707 16.0405C10.5195 16.2281 10.2651 16.3334 9.99991 16.3334C9.7347 16.3334 9.48034 16.2281 9.29281 16.0405L5.95947 12.7072L7.37369 11.293L9.99991 13.9192Z"
        />
      </svg>
    );
  }
);
